import { FormikErrors } from 'formik';

import { useDebounce } from '@/react/hooks/useDebounce';

import { AuthTypeOption, Provider } from '../../account/git-credentials/types';
import { GitCredentialSection } from '../../account/git-credentials/components/GitCredentialSection';
import { GitAuthModel } from '../types';
import { isBE } from '../../feature-flags/feature-flags.service';

import { NewCredentialForm } from './NewCredentialForm';

export function CredentialsSection({
  value,
  onChange,
  errors,
}: {
  value: GitAuthModel;
  onChange: (value: Partial<GitAuthModel>) => void;
  errors?: FormikErrors<GitAuthModel>;
}) {
  const [username, setUsername] = useDebounce(
    value.RepositoryUsername || '',
    (username) => onChange({ RepositoryUsername: username })
  );
  const [password, setPassword] = useDebounce(
    value.RepositoryPassword || '',
    (password) => onChange({ RepositoryPassword: password })
  );
  const [provider, setProvider] = useDebounce(
    value.RepositoryProvider || Provider.Custom,
    (provider) => onChange({ RepositoryProvider: provider })
  );
  const [authType, setAuthType] = useDebounce(
    value.RepositoryAuthorizationType || AuthTypeOption.Basic,
    (authType) => onChange({ RepositoryAuthorizationType: authType })
  );

  return (
    <>
      <GitCredentialSection
        provider={provider}
        authorizationType={authType}
        username={username}
        password={password}
        errors={{
          username: errors?.RepositoryUsername as string | undefined,
          password: errors?.RepositoryPassword as string | undefined,
        }}
        onChange={({ provider, username, password, authorizationType }) => {
          if (username !== undefined) setUsername(username);
          if (password !== undefined) setPassword(password);
          if (provider !== undefined) setProvider(provider);
          if (authorizationType !== undefined) setAuthType(authorizationType);
        }}
      />
      {isBE && value.RepositoryPassword && (
        <NewCredentialForm value={value} onChange={onChange} errors={errors} />
      )}
    </>
  );
}
